module.exports = __webpack_public_path__ + "img/SpareFoot.ca17c255.png";